
import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IPaging } from "@core/data-access/model";
import { IImageMockup } from "../model/domain/image-mockup";
import { IImageMockupRestService } from "./image-mockup-rest";


export class ImageMockupRestService extends AbstractAccessorService<IImageMockup> implements IImageMockupRestService {
    public readonly $name: string = "imageMockupRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IImageMockup>) {
        super();
    }

    public download(fileName: string): angular.IPromise<IResponse<IPaging<any>>> {
        return this.$accessor<any, { fileName: string }, "download">(this.$name, "download", {
            parameter: { fileName: fileName }
        });
    }
    /**
     * @description 重新生成mockup图片（同步）
     * @param imageId
     * */ 
    public retry(imageId: string): angular.IPromise<IResponse<IImageMockup>> {
        return this.$accessor<IImageMockup, { imageId: string, async: boolean }, "retry">(this.$name, "retry", {
            parameter: {
                imageId: imageId,
                async: false
            }
        });
    }
}